module.exports = __webpack_public_path__ + "static/media/jingly.c1a0e1f2.mp3";